import React from 'react';
import cn from 'classnames';
import migrateNode from 'legacy-src/utility/migrate';
import log from 'chameleon/ui-stack/utilities/log';

const RichTitle = (props) => {
  const { extra } = props;
  const classes = cn('rich_title_wrapper', props.maxWidth, props.className);

  if (!props.title) {
    return null;
  }

  let title = props.title;

  if (typeof title === 'object') {
    return (
      <div className={classes} {...extra}>
        {richTextNode(migrateNode(title))}
      </div>
    );
  }
  return (
    <div
      className={classes}
      dangerouslySetInnerHTML={{ __html: title || '' }}
      {...extra}
    />
  );
};

export default RichTitle;

function richTextNode(node, index) {
  if (node.type in NODE_TYPES) {
    return NODE_TYPES[node.type](node, { key: index });
  }
  log('warn', `No node rendering function found for ${JSON.stringify(node)}`);
  return null;
}

function contents(data, props) {
  if (data.content) {
    return data.content.map(richTextNode);
  }
  const marks = data.styles || data.marks;
  if (marks) {
    const node = marks.reduce(applyMark, data.text);
    return React.cloneElement(node, props);
  }
  return data.text;
}

function wrapper(tag) {
  return function (data, props) {
    return React.createElement(tag, props, contents(data));
  };
}

const NODE_TYPES = {
  doc(data) {
    return <div className="doc">{contents(data)}</div>;
  },
  paragraph: wrapper('p'),
  text: contents,
};

function applyMark(content, mark) {
  const markType = mark.type || mark._ || mark;
  if (markType in MARKS) {
    return MARKS[markType](content, mark);
  }
  return React.createElement(markType, {}, content);
}

const MARKS = {
  link(content, mark) {
    return <a {...mark}>{content}</a>;
  },
};
